export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./UscopeComponent.vue?vue&type=template&id=018c7439&"


//////////////////
// WEBPACK FOOTER
// ./src/viewer/components/UscopeComponent.vue?vue&type=template&id=018c7439&
// module id = 313
// module chunks = 0